var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupmodalimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 121,
    viewBox: "0 0 149 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.771 2.46467C108.452 2.46467 109.004 1.91293 109.004 1.23233C109.004 0.551733 108.452 0 107.771 0C107.091 0 106.539 0.551733 106.539 1.23233C106.539 1.91293 107.091 2.46467 107.771 2.46467Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.355 87.6912C117.036 87.6912 117.588 87.1395 117.588 86.4589C117.588 85.7783 117.036 85.2266 116.355 85.2266C115.675 85.2266 115.123 85.7783 115.123 86.4589C115.123 87.1395 115.675 87.6912 116.355 87.6912Z",
    fill: "#1976D2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.018 45.4696C89.4666 45.4696 78.7495 45.0403 68.7247 42.2572C58.6999 39.4741 49.8797 34.2263 41.7796 28.0923C36.5041 24.0907 31.6855 20.9199 24.8593 21.4045C18.1591 21.7569 11.7505 24.2573 6.58199 28.5354C-2.12741 36.1648 -0.812001 50.2604 2.66345 60.1883C7.91124 75.1424 23.8485 85.5134 37.3903 92.2843C53.0367 100.094 70.2201 104.635 87.4589 107.252C102.621 109.537 121.978 111.212 135.063 101.34C147.095 92.2843 150.391 71.5839 147.442 57.6129C146.729 53.4799 144.527 49.7511 141.252 47.1312C132.806 40.9557 120.206 45.0819 110.79 45.2896C107.19 45.3727 103.618 45.4557 100.018 45.4696Z",
    fill: "#1976D2",
    fillOpacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.861 25.5195V30.9473",
    stroke: "#1976D2",
    strokeWidth: 0.969249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.161 28.2344H144.575",
    stroke: "#1976D2",
    strokeWidth: 0.969249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.475 26.8955L29.8105 18.425C27.0378 18.1795 24.591 20.2282 24.3455 23.0009L18.3895 90.2667C18.144 93.0394 20.1927 95.4862 22.9654 95.7317L118.63 104.202C121.403 104.448 123.849 102.399 124.095 99.6263L130.051 32.3605C130.296 29.5878 128.248 27.141 125.475 26.8955Z",
    fill: "#1976D2",
    stroke: "white",
    strokeWidth: 1.38464,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.358 51.4924L48.2642 46.7027C46.9997 46.5908 45.8838 47.5251 45.7719 48.7896L45.4385 52.5549C45.3265 53.8194 46.2608 54.9352 47.5253 55.0472L101.619 59.8369C102.884 59.9488 104 59.0145 104.112 57.75L104.445 53.9847C104.557 52.7202 103.623 51.6044 102.358 51.4924Z",
    fill: "white",
    stroke: "#1976D2",
    strokeOpacity: 0.3,
    strokeWidth: 1.38464,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.914 67.762L46.8198 62.9723C45.5553 62.8603 44.4395 63.7946 44.3275 65.0591L43.9941 68.8244C43.8822 70.0889 44.8165 71.2047 46.081 71.3167L100.175 76.1064C101.439 76.2184 102.555 75.284 102.667 74.0196L103.001 70.2542C103.113 68.9898 102.178 67.8739 100.914 67.762Z",
    fill: "white",
    stroke: "#1976D2",
    strokeOpacity: 0.3,
    strokeWidth: 1.38464,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5999 82.7322L63.2145 81.1043C62.2471 81.0187 61.3935 81.7335 61.3078 82.7009L60.8791 87.542C60.7935 88.5094 61.5083 89.3631 62.4757 89.4488L80.861 91.0767C81.8284 91.1623 82.6821 90.4475 82.7678 89.4801L83.1964 84.639C83.2821 83.6716 82.5673 82.8179 81.5999 82.7322Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1538 81.794L81.5389 83.4219C82.1254 83.4739 82.559 83.9917 82.5071 84.5782L82.0785 89.4187C82.0265 90.0052 81.5087 90.4388 80.9222 90.3869L62.5371 88.759C61.9505 88.707 61.5169 88.1892 61.5689 87.6027L61.9975 82.7622C62.0494 82.1757 62.5672 81.7421 63.1538 81.794Z",
    stroke: "#1976D2",
    strokeOpacity: 0.3,
    strokeWidth: 1.38464
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4851 54.3882C61.8004 54.3882 62.8667 53.3219 62.8667 52.0066C62.8667 50.6913 61.8004 49.625 60.4851 49.625C59.1698 49.625 58.1035 50.6913 58.1035 52.0066C58.1035 53.3219 59.1698 54.3882 60.4851 54.3882Z",
    fill: "#1976D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1228 55.2319C71.4381 55.2319 72.5044 54.1656 72.5044 52.8503C72.5044 51.535 71.4381 50.4688 70.1228 50.4688C68.8075 50.4688 67.7412 51.535 67.7412 52.8503C67.7412 54.1656 68.8075 55.2319 70.1228 55.2319Z",
    fill: "#1976D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7595 56.0913C81.0748 56.0913 82.1411 55.025 82.1411 53.7097C82.1411 52.3944 81.0748 51.3281 79.7595 51.3281C78.4442 51.3281 77.3779 52.3944 77.3779 53.7097C77.3779 55.025 78.4442 56.0913 79.7595 56.0913Z",
    fill: "#1976D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3835 56.935C90.6989 56.935 91.7651 55.8688 91.7651 54.5534C91.7651 53.2381 90.6989 52.1719 89.3835 52.1719C88.0682 52.1719 87.002 53.2381 87.002 54.5534C87.002 55.8688 88.0682 56.935 89.3835 56.935Z",
    fill: "#1976D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3137 118.089C88.7124 119.158 103.682 119.095 103.748 117.948C103.815 116.801 88.9537 115.005 70.555 113.936C52.1563 112.867 37.1872 112.93 37.1205 114.076C37.0539 115.223 51.915 117.02 70.3137 118.089Z",
    fill: "#1976D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8838 22.3486C65.6856 13.6671 74.1169 8.028 82.7822 9.9082L82.7852 9.90918C85.882 10.5611 88.5828 12.1091 90.8887 14.2461H90.8896C94.7348 18.0914 96.3707 23.6528 95.2295 28.8828C94.8997 30.2842 94.4068 31.7641 93.8359 32.9912C92.2841 36.0123 89.8332 38.3848 86.8008 39.9434C83.6822 41.5026 80.0014 42.1535 76.3311 41.3379L76.3232 41.3359L75.9189 41.2471C67.4774 39.27 62.1114 30.8889 63.8838 22.3486Z",
    fill: "#1976D2",
    stroke: "#CFE7FF",
    strokeWidth: 1.09164
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2275 25.4043L77.6858 31.0081L88.6022 19",
    stroke: "white",
    strokeWidth: 1.96496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupmodalimage);
export default __webpack_public_path__ + "static/media/groupmodalimage.e0f9366cec0ad3fbfe00fbbb6c34eb60.svg";
export { ForwardRef as ReactComponent };